module.exports = __webpack_public_path__ + "static/media/logo-sa.a7dbbfbf.png";